import { render } from "./StrandedOrders.vue?vue&type=template&id=222f8a2a&scoped=true"
import script from "./StrandedOrders.vue?vue&type=script&lang=js"
export * from "./StrandedOrders.vue?vue&type=script&lang=js"

import "./StrandedOrders.vue?vue&type=style&index=0&id=222f8a2a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222f8a2a"]])

export default __exports__